import { useCallback, useRef, useState } from "react"
import { numberFormat } from "shared/util"
import { Stack, StackProps, Button, Slider } from "@mui/material"
import { ReasonIcon } from 'shared/icons'
import { TargetListResult } from "interface/search/targetList"

import { ValueSpan } from "components/controls/valueSpan"
import { SetExtendCountDialog } from "./dialog/setExtendCountDialog"
import { TargetListReasonDialog } from "features/search/targetList/reason/dialog/targetListReasonDialog"

type TargetListExtendBarProps = {
	searchId: number
	targetList: TargetListResult
	count: number
	source: number
	extend: number
	extended: number,
	extendThresholdRate: number
	setExtendThreshold: (rate: number, count?: number) => void
} & StackProps
export const TargetListExtendBar = ({
	searchId,
	targetList,
	count,
	source,
	extend,
	extended,
	extendThresholdRate,
	setExtendThreshold,
	...others
}: TargetListExtendBarProps) => {
  const inputTimer = useRef<NodeJS.Timeout | null>(null)
	const [modal, setModal] = useState<'reasonDialog' | 'extendCount' | null>(null)

	const onChangeRateThreshold = useCallback(
		(value: number) => {
			if (inputTimer.current) clearTimeout(inputTimer.current)
			inputTimer.current = setTimeout(() => {
				setExtendThreshold(value)
				inputTimer.current = null
			}, 100)
		},
		[inputTimer, setExtendThreshold]
	)
	return (
		<>
			<Stack {...others} direction="row" paddingX={1} spacing={1} alignItems="center">
				<Button
					size="medium"
					color="primary"
					startIcon={<ReasonIcon />}
					sx={{ whiteSpace: 'nowrap' }}
					onClick={() => setModal('reasonDialog')}
				>
					組入条件
				</Button>

				<Stack
					width={200}
					paddingX={1}
					direction="row"
					alignItems="center"
				>
					<Slider
						valueLabelDisplay="off"
						min={0}
						max={100}
						value={extendThresholdRate}
						onChange={(e, value) => {
							if (!Array.isArray(value)) onChangeRateThreshold(value)
						}}
					/>
				</Stack>

				<Stack direction="row" spacing={1} alignItems="center">
					<Button size="small" onClick={() => setModal('extendCount')}>
						<ValueSpan text={numberFormat(count, '-')} suffix='人'/>
						<ValueSpan prefix="（" text={numberFormat(source, '-')} suffix='人'/>
						<ValueSpan prefix="＋" text={numberFormat(extended, '-')} suffix='人）'/>
					</Button>
				</Stack>
			</Stack>

			{modal === 'reasonDialog' ? (
        <TargetListReasonDialog
          searchId={searchId}
          listId={targetList.listId}
          onClose={() => setModal(null)}
        />
			) : modal === 'extendCount' ? (
        <SetExtendCountDialog
          listTitle={targetList.listName}
          sourceCount={source}
          extendCount={extend}
          limitted={extended}
          rateThreshold={extendThresholdRate}
          onApply={setExtendThreshold}
          onClose={() => setModal(null)}
        />
      ) : <></> }
		</>
	)
}